import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["It's Sunday night and you still don't know what you're teaching on Monday", "Planning next week's class on your own time — unpaid", 'Six-year-olds and twelve-year-olds in the same room, and one plan for all of them', 'Making up a new combo in the car on the way to class', 'Teaching the same three routines because there is no time to write new ones', 'Losing the room halfway through class and struggling to get it back', 'Scrolling for an hour to find clean, kid-friendly music at the right tempo', 'Showcase season is coming and there is no routine written yet'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-plum" data-id="element-187" data-mp="17oitnqum0syx">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-188" data-mp="17qc3tg4flvbo">
        <div className="text-center" data-id="element-189" data-mp="362u5i8cdd6nd">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-190" data-mp="361rfs3qs9a91">
            The part nobody pays you for
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-191" data-mp="3g8tul6omitxw">
            If you teach kids&apos; dance, you know at least{' '}
            <span className="text-coral-soft" data-id="element-192" data-mp="379zs4zom39cf">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-193" data-mp="3baij6riokbdk">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-2xl border border-plum-line bg-plum-card px-4 py-4 text-sm text-white/85" data-id="element-194" data-mp="2wa0cb5ymyyl">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/20" data-id="element-195" data-mp="3q6rfplb6sama">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-196" data-mp="3u6rvb9a0urux" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display font-semibold text-2xl sm:text-3xl text-gold leading-tight" data-id="element-197" data-mp="10frqe1hzvyvm">
          How many more Sunday nights do you want to spend planning?
        </p>
      </div>
    </section>;
}